import { useMutation, useQueryClient } from '@tanstack/react-query';
import { findActionIn, invokeAction } from 'actions';
import { useAuthStatus } from 'features/auth';
/** Shared mutationKey so consumers can detect in-flight removes via `useIsMutating`. */
export const REMOVE_AGENT_KEY = ['removeAgent'];
export function useRemoveAgent() {
    const authStatus = useAuthStatus();
    const user = authStatus.kind === 'authenticated' ? authStatus.user : null;
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: [...REMOVE_AGENT_KEY],
        mutationFn: async ({ agent }) => {
            if (!user)
                throw new Error('not authenticated');
            const action = findActionIn(agent.potentialAction, 'remove');
            if (!action)
                throw new Error('remove action unavailable for this agent');
            if (!agent.id)
                throw new Error('agent.id missing');
            const response = await invokeAction(action, user.token, {
                body: { object: agent.id },
            });
            if (!response.ok)
                throw new Error(`removeAgent returned ${response.status}`);
        },
        onSuccess: (_data, { agent }) => {
            if (agent.UUID && user?.email) {
                queryClient.removeQueries({ queryKey: ['getAgent', user.email, agent.UUID] });
            }
            // Mark the list stale explicitly — the global staleTime means the
            // mount-refetch on navigating back would otherwise serve cached data
            // still containing the deleted agent. The list isn't mounted at this
            // point, so this is a single fetch on next mount, not a redundant one.
            void queryClient.invalidateQueries({ queryKey: ['listAgents', user?.email] });
        },
    });
}
